import { DBMetadataDB } from '@/db/repositories/DBMetadataRepo';

export type DBMetadataKey =
  | 'getPlayersWithTourAndBioV2'
  | 'getTournaments'
  | 'getOrderNotificationEvents'
  | 'getTours'
  | 'getHeadTypeLofts'
  | 'getHeadTypeFamilies'
  | 'getFamilies'
  | 'getFedExCupPlayers'
  | 'getHeadFinishes'
  | 'getHeadModelHandsForDropdown'
  | 'getHeadModelsByManufacturerAndTypeForDropdown'
  | 'getHeadModelsByManufacturerAndTypeForDropdownHybrid'
  | 'getHeadModelsByManufacturerAndTypeForDropdownWedges'
  | 'getHeadModelsByManufacturerAndTypeForDropdownFairway'
  | 'getIronHeadModelsByManufacturerAndTypeForDropdown'
  | 'getHandLookup'
  | 'getCtLocations'
  | 'getSettings'
  | 'getSleeves'
  | 'getSwingWtPrefix'
  | 'getSwingWtSuffix'
  | 'getGripSizes'
  | 'getFractions'
  | 'getHeadWeightLocationLookups'
  | 'getHeadWeightLocations'
  | 'getHeadWeightNumbers'
  | 'getHeadWeightNumberLookups'
  | 'getHeadWeightLocationAft'
  | 'getHeadWeightLocationBack'
  | 'getHeadWeightNumberAft'
  | 'getHeadWeightNumberBack'
  | 'getShaftByShaftNameForDropdown'
  | 'getIronShaftByShaftNameForDropdown'
  | 'getWedgeShaftByShaftNameForDropdown'
  | 'getHybridShaftByShaftNameForDropdown'
  | 'getShaftByShaftNameForDropdown'
  | 'getShaftLengthDigits'
  | 'getShaftLengthFractions'
  | 'getShaftTippingFractions'
  | 'getGripTypes'
  | 'getDigits'
  | 'getLofts'
  | 'getLieDigits'
  | 'getLieFractions'
  | 'getLoftDigits'
  | 'getLoftFractions'
  | 'getPutterFaces'
  | 'getPutterGrips'
  | 'getPutterHeadFinishes'
  | 'getPutterHeadModels'
  | 'getPutterLevels'
  | 'getPutterNecks'
  | 'getPutterShafts'
  | 'getPutterSightlines'
  | 'getPutterTypes'
  | 'getPutterWeights'
  | 'getHeadTypeDto'
  | 'getIronClubs'
  | 'getBsgBalls'
  | 'getBsgGloves'
  | 'getBsgGloveSizes'
  | 'getBsgHeadwear'
  | 'getBsgShoes'
  | 'getBsgShoeSizes'
  | 'getBsgShoeWidths'
  | 'getGolfBags'
  | 'getTourBagsForPWA'
  | 'getLoftsAndHandAndHeadModel'
  | 'getAppMenus'
  | 'getPlayerRegionLookups'
  | 'getPlayerStatusLookups'
  | 'getPlayerInternalStatuses'
  | 'getInternalStatusLookups'
  | 'getNationalities'
  | 'getPlayerCollegeLookups'
  | 'getPlayerYearLookups'
  | 'getPlayerSupportLookups'
  | 'getOrderAccountsForDropdown'
  | 'getOrderStatusList'
  | 'getHeadModelWeightPutters'
  | 'getBuildLocationsForDropdown'
  | 'getAppUsersForDropdown';

const oneDay = 1000 * 60 * 60 * 24; // 24 hours
const oneWeek = oneDay * 7;
// const twelveHours = 1000 * 60 * 60 * 12;  // 12 hours
// const sixHours = 1000 * 60 * 60 * 6;      // 6 hours
// const oneHour = 1000 * 60 * 60 * 1;       // 1 hour
//const tenMinutes = 1000 * 60 * 10; // 10 minutes
// const fiveMinutes = 1000 * 60 * 5; // 5 minutes

export const dbMetadataExpiration: Record<DBMetadataKey, number> = {
  getPlayersWithTourAndBioV2: oneDay,
  getTours: oneDay,
  getTournaments: oneDay,
  getOrderNotificationEvents: oneDay,
  getHeadTypeLofts: oneWeek,
  getHeadTypeFamilies: oneWeek,
  getFamilies: oneWeek,
  getFedExCupPlayers: oneWeek,
  getHeadFinishes: oneWeek,
  getHeadModelHandsForDropdown: oneWeek,
  getHeadModelsByManufacturerAndTypeForDropdown: oneWeek,
  getHeadModelsByManufacturerAndTypeForDropdownFairway: oneWeek,
  getHeadModelsByManufacturerAndTypeForDropdownHybrid: oneWeek,
  getHeadModelsByManufacturerAndTypeForDropdownWedges: oneWeek,
  getIronHeadModelsByManufacturerAndTypeForDropdown: oneWeek,
  getHandLookup: oneWeek,
  getHeadTypeDto: oneWeek,
  getCtLocations: oneWeek,
  getSettings: oneWeek,
  getSleeves: oneWeek,
  getSwingWtPrefix: oneWeek,
  getSwingWtSuffix: oneWeek,
  getGripSizes: oneWeek,
  getFractions: oneWeek,
  getHeadWeightLocationLookups: oneWeek,
  getHeadWeightLocations: oneWeek,
  getHeadWeightNumbers: oneWeek,
  getHeadWeightNumberLookups: oneWeek,
  getHeadWeightLocationAft: oneWeek,
  getHeadWeightLocationBack: oneWeek,
  getHeadWeightNumberAft: oneWeek,
  getHeadWeightNumberBack: oneWeek,
  getShaftByShaftNameForDropdown: oneWeek,
  getIronShaftByShaftNameForDropdown: oneWeek,
  getWedgeShaftByShaftNameForDropdown: oneWeek,
  getHybridShaftByShaftNameForDropdown: oneWeek,
  getShaftLengthDigits: oneWeek,
  getShaftLengthFractions: oneWeek,
  getShaftTippingFractions: oneWeek,
  getGripTypes: oneWeek,
  getDigits: oneWeek,
  getLieDigits: oneWeek,
  getLieFractions: oneWeek,
  getLofts: oneWeek,
  getLoftDigits: oneWeek,
  getLoftFractions: oneWeek,
  getPutterFaces: oneWeek,
  getPutterGrips: oneWeek,
  getPutterHeadFinishes: oneWeek,
  getPutterHeadModels: oneWeek,
  getPutterLevels: oneWeek,
  getPutterNecks: oneWeek,
  getPutterShafts: oneWeek,
  getPutterSightlines: oneWeek,
  getPutterTypes: oneWeek,
  getPutterWeights: oneWeek,
  getIronClubs: oneWeek,
  getBsgBalls: oneWeek,
  getBsgGloves: oneWeek,
  getBsgGloveSizes: oneWeek,
  getBsgHeadwear: oneWeek,
  getBsgShoes: oneWeek,
  getBsgShoeSizes: oneWeek,
  getBsgShoeWidths: oneWeek,
  getGolfBags: oneWeek,
  getTourBagsForPWA: oneDay, // TODO: Check if we need more time
  getLoftsAndHandAndHeadModel: oneWeek,
  getAppMenus: oneDay,
  getPlayerRegionLookups: oneWeek,
  getPlayerStatusLookups: oneWeek,
  getPlayerInternalStatuses: oneWeek,
  getInternalStatusLookups: oneWeek,
  getNationalities: oneWeek,
  getPlayerCollegeLookups: oneWeek,
  getPlayerYearLookups: oneWeek,
  getPlayerSupportLookups: oneWeek,
  getOrderAccountsForDropdown: oneWeek,
  getOrderStatusList: oneWeek,
  getHeadModelWeightPutters: oneWeek,
  getBuildLocationsForDropdown: oneWeek,
  getAppUsersForDropdown: oneDay,
};

export const getDBUpdatedOn = async (key: DBMetadataKey): Promise<string | undefined> => {
  return DBMetadataDB.getLastUpdatedAt(key);
};

export const setDBUpdatedOn = async (key: DBMetadataKey, isoDateString: string): Promise<void> => {
  await DBMetadataDB.setLastUpdatedAt(key, isoDateString);
};

export const setDBUpdatedNow = async (key: DBMetadataKey): Promise<void> => {
  const now = new Date().toISOString();
  await setDBUpdatedOn(key, now);
};

export const isDBEntryStale = async (key: DBMetadataKey, metadataDict?: Record<string, string>): Promise<boolean> => {
  const expiry = dbMetadataExpiration[key as keyof typeof dbMetadataExpiration];
  const lastUpdated = metadataDict ? metadataDict[key] : await getDBUpdatedOn(key);

  if (!lastUpdated || !expiry) return true;

  const age = Date.now() - new Date(lastUpdated).getTime();
  return age > expiry;
};
